import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import BouncingDots from "../../loading/BouncingDots";
import ImportFieldStatus from "../../tables/ImportFieldStatus";
import { limeGreen } from "../../../styles/dashComponentStyles/myDashboard";
import h from "../../../helpers";

type Props = {};

interface IImportLogArray {
    Id: number;
    Status: number;
    Message: string;
    ImportUserId: number;
    ImportStartDate: string;
}
const ImportBulkLogMain: React.FC<Props> = () => {
    const dispatch = useDispatch();

    const [filteredImportSummaries, setFilteredImportSummaries] = useState<Array<IImportLogArray>>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const url = "/Field/Importfieldlogfor";
        fetch(url, { method: "POST", credentials: "same-origin" })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    importLog: Array<IImportLogArray>;
                };
                setFilteredImportSummaries(response.importLog);
                setLoading(false);
            });
    }, [dispatch]);

    return (
        <div>
            {loading && (
                <div style={{ marginTop: "25px", textAlign: "center" }}>
                    <BouncingDots />
                </div>
            )}
            <div
                style={{
                    backgroundColor: limeGreen[0],
                    paddingLeft: "0px",
                    paddingTop: "0px",
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", marginBottom: "10px", marginRight: "5px" }}>
                        <div
                            style={{
                                display: "table-cell",
                                paddingLeft: "10px",
                                paddingTop: "10px",
                                color: "#FFF",
                                fontSize: "18px",
                            }}
                        >
                            Import Fields / Tree Visibility Status
                            <div style={{ fontSize: "14px" }}>
                                Check the status of imported fields / Tree Visibility.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ padding: "0px 0px 0px 0px" }}>
                <Paper>
                    <ImportFieldStatus filteredImportSummaries={filteredImportSummaries} />
                </Paper>
            </div>
        </div>
    );
};

export default ImportBulkLogMain;
